// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1urFO","additionalInfo":"AgreementModal_additionalInfo__3jilY"};